import { useEffect } from 'react';
import { useGetAppVersionQuery, useUpdateUserAppVersionMutation } from 'services/appStatusService';

export const useAppStatus = () => {
  const { data: versionInfo } = useGetAppVersionQuery();
  const version = versionInfo?.releaseVersion || '';

  return {
    version,
  };
};

// This hook is not being used. Keeping the code here for future use cases.
// Ref Ticket : https://healthedge.atlassian.net/browse/WFMOB-16284
export const useUpdateAppVersionOnLogin = (userId?: number, isLoggedIn?: boolean) => {
  const { version } = useAppStatus();
  const [updateUserAppVersion] = useUpdateUserAppVersionMutation();

  useEffect(() => {
    const updateProgramUserWithAppVersion = async () => {
      if (userId && version) {
        await updateUserAppVersion({ id: userId, version });
      }
    };

    if (isLoggedIn) {
      updateProgramUserWithAppVersion();
    }
  }, [isLoggedIn, version, userId, updateUserAppVersion]);
};
